const readerData = require("./readers/readers.json");
const pro = 2349.0;
const lite = 1799.0;
const go = 999.0;

const proDiscount = Number.isInteger(readerData["miura-m010"].discount)
  ? readerData["miura-m010"].discount
  : 0;
const liteDiscount = Number.isInteger(readerData["miura-shuttle"].discount)
  ? readerData["miura-shuttle"].discount
  : 0;
const goDiscount = Number.isInteger(readerData["qpos-mini"].discount)
  ? readerData["qpos-mini"].discount
  : 0;
function getWeekly(cost, discount) {
  return (((cost - discount) * 1.3 + 50) / 16).toFixed(2);
}
console.log(readerData["miura-m010"].financeRates["6month"]);
module.exports = {
  pro: pro,
  lite: lite,
  go: go,
  // proWeekly: getWeekly(pro, proDiscount),
  // liteWeekly: getWeekly(lite, liteDiscount),
  // goWeekly: getWeekly(go, goDiscount),
  proWeekly: Number.isInteger(readerData["miura-m010"].financeRates["6month"])
    ? readerData["miura-m010"].financeRates["6month"]
    : 125,
  liteWeekly: Number.isInteger(
    readerData["miura-shuttle"].financeRates["6month"]
  )
    ? readerData["miura-shuttle"].financeRates["6month"]
    : 50,
  goWeekly: Number.isInteger(readerData["qpos-mini"].financeRates["6month"])
    ? readerData["qpos-mini"].financeRates["6month"]
    : 50,
  discountPro: proDiscount,
  discountLite: liteDiscount,
  discountGo: goDiscount
};



// WEBPACK FOOTER //
// ./src/data/pricing.js